// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__7bbZb","form":"styles_form__4dJ7B","userRow":"styles_userRow__mNPeo","table":"styles_table__UBHo-"};